import { cn } from "@lib/styling";
import { Button } from "@ui/button";
import { AlertTriangleIcon } from "lucide-react";
import type { ReactNode } from "react";

type ErrorFallbackAction = {
  label: string;
  onClick: () => void;
};

type ErrorFallbackProps = {
  actions: ErrorFallbackAction[];
  className?: string;
  message: string;
};

export function ErrorFallback({
  actions,
  className,
  message,
}: ErrorFallbackProps): ReactNode {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-6 p-8",
        className,
      )}
    >
      <AlertTriangleIcon className="size-12 text-destructive" />
      <div className="flex flex-col items-center gap-2">
        <h1 className="font-semibold text-xl">Something went wrong</h1>
        <p className="text-muted-foreground text-sm">{message}</p>
      </div>
      <div className="flex gap-3">
        {actions.map((action) => (
          <Button key={action.label} variant="outline" onClick={action.onClick}>
            {action.label}
          </Button>
        ))}
      </div>
    </div>
  );
}
